<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
  >
    <v-btn
      slot="activator"
      icon
    >
      <v-icon color="error">delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Eintrag löschen</span>
      </v-card-title>
      <v-card-text>
        Möchtest du das Angebot wirklich löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :loading="loading"
          color="error"
          flat
          @click.native="remove()"
        >Löschen
        </v-btn>
        <v-btn
          color="blue darken-1"
          flat
          @click.native="dialog = false"
        >Abbrechen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'DlgAdDelete',
    props: {
      ad: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    methods: {
      ...mapActions({
        removeAd: 'ads/remove',
        readAll: 'ads/read',
      }),
      remove() {
        this.loading = true;
        this.removeAd(this.ad).then((res) => {
          this.loading = false;
          if (res) {
            this.readAll();
            this.dialog = false;
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
